import React from 'react';
import { useTranslation } from 'react-i18next';

const ICONS = {
  episodes: '🎙',
  live: '📡',
  search: '🔍',
  manage: '📋',
};

const QtEmptyState = ({ variant = 'episodes', actions }) => {
  const { t } = useTranslation();
  const title = t(`qoreTalks.empty.${variant}.title`);
  const desc = t(`qoreTalks.empty.${variant}.desc`);

  return (
    <div className="qt-empty" role="status">
      <div className="qt-empty__icon" aria-hidden>
        {ICONS[variant] || '🎙'}
      </div>
      <h3>{title}</h3>
      <p>{desc}</p>
      {actions && <div className="qt-empty__actions">{actions}</div>}
    </div>
  );
};

export default QtEmptyState;